import services from "@/config/services";
import axios from "axios";
import authHeader from "../auth/auth-header";
import Cookies from "js-cookie";
import FileManager from "@/services/ask-file-manager/index.js";

export default class CheckRcuService {
  constructor(eventBus) {
    this.eventBus = eventBus;
    this.baseUrl = `${services.ask_pratiche.url}`;
    this.baseUrlApi = `${services.ask_api.url}`;
    this.filemanager = new FileManager();

    axios.interceptors.request.use((req) => {
      req.headers["Authorization"] = authHeader();
      req.headers["Params"] =
        Cookies.get("google_access_token") || Cookies.get("ask_access_token");
      if (this.eventBus) {
        this.eventBus.emit('data-loading');
      }
      return req;
    });
  }

  async getListCheckRcu(date) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListCheckRcu`;
    let fd = new FormData();
    fd.append('date', date);

    try {
      let res = await axios({
        url,
        method: 'POST',
        data: fd,
      });
      if (this.eventBus) {
        this.eventBus.emit('data-load-success', { message: 'Dati Caricati Con Successo' });
      }
      return res.data;
    } catch (err) {
      if (this.eventBus) {
        this.eventBus.emit('data-load-error', { message: err, url });
      }
      throw err;
    } finally {
      if (this.eventBus) {
        this.eventBus.emit('data-loaded');
      }
    }
  }

  async getListCheckRcuGas(date) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListCheckRcuGas`;
    let fd = new FormData();
    fd.append('date', date);

    try {
      let res = await axios({
        url,
        method: 'POST',
        data: fd,
      });
      if (this.eventBus) {
        this.eventBus.emit('data-load-success', { message: 'Dati Caricati Con Successo' });
      }
      return res.data;
    } catch (err) {
      if (this.eventBus) {
        this.eventBus.emit('data-load-error', { message: err, url });
      }
      throw err;
    } finally {
      if (this.eventBus) {
        this.eventBus.emit('data-loaded');
      }
    }
  }

  async getListSeda(date) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListSeda`;
    let fd = new FormData();
    fd.append('date', date);

    try {
      let res = await axios({
        url,
        method: 'POST',
        data: fd,
      });
      if (this.eventBus) {
        this.eventBus.emit('data-load-success', { message: 'Dati Caricati Con Successo' });
      }
      return res.data;
    } catch (err) {
      if (this.eventBus) {
        this.eventBus.emit('data-load-error', { message: err, url });
      }
      throw err;
    } finally {
      if (this.eventBus) {
        this.eventBus.emit('data-loaded');
      }
    }
  }

  async getListSedaGas(date) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListSedaGas`;
    let fd = new FormData();
    fd.append('date', date);

    try {
      let res = await axios({
        url,
        method: 'POST',
        data: fd,
      });
      if (this.eventBus) {
        this.eventBus.emit('data-load-success', { message: 'Dati Caricati Con Successo' });
      }
      return res.data;
    } catch (err) {
      if (this.eventBus) {
        this.eventBus.emit('data-load-error', { message: err, url });
      }
      throw err;
    } finally {
      if (this.eventBus) {
        this.eventBus.emit('data-loaded');
      }
    }
  }

  async changeTipoRid(payload) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/ChangeTipoRid`;
    try {
      let res = await axios.post(url, payload);
      if (this.eventBus) {
        this.eventBus.emit('data-load-success', { message: 'Tipo RID cambiato con successo' });
      }
      return res.data;
    } catch (err) {
      if (this.eventBus) {
        this.eventBus.emit('data-load-error', { message: err, url });
      }
      throw err;
    } finally {
      if (this.eventBus) {
        this.eventBus.emit('data-loaded');
      }
    }
  }

  async exportRecord(contractId) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/testSeda`;
    try {
        const formData = new FormData();
        formData.append('idContracts', contractId);

        const res = await axios.post(url, formData, {
            responseType: 'blob' 
        });

        const blob = new Blob([res.data], { type: 'application/xml' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `FLUSSO_MANDATI_RID_${new Date().toISOString().slice(0, 19).replace(/[-T:]/g, '')}.xml`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        if (this.eventBus) {
            this.eventBus.emit('data-load-success', { message: 'Record esportato con successo' });
        }
    } catch (err) {
        if (this.eventBus) {
            this.eventBus.emit('data-load-error', { message: err, url });
        }
        throw err;
    } finally {
        if (this.eventBus) {
            this.eventBus.emit('data-loaded');
        }
    }
  }

  async updateSedaStatus(record) {
    console.log('Record:', record); 
  
    try {
      const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/updateSedaStatus`;
      const payload = {
        contrattoId: record.contrattoId, 
        stato_seda: record.stato_seda
      };
  
      console.log('Payload:', payload); 
  
      const response = await axios.post(url, payload);
      console.log('Response:', response.data.message);
    } catch (error) {
      console.error('Errore durante l\'aggiornamento dello stato SEDA:', error);
    }
  }

  async getListDialogChangeRid(iban) {
    const url = `${this.baseUrlApi}/management/AreaFlussi/caricamento-flows/getListDialogChangeRid`;
    let fd = new FormData();
    fd.append('iban', iban);
  
    try {
      let res = await axios({
        url,
        method: 'POST',
        data: fd,
      });
      return res.data;
    } catch (err) {
      if (this.eventBus) {
        this.eventBus.emit('data-load-error', { message: err, url });
      }
      throw err;
    }
  }
  
  
}
